var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowingMessage
    ? _c(
        "div",
        {
          staticClass: "flex message-wrapper",
          class: {
            "flex-right": _vm.isFromSubscriber,
            "new-message": _vm.message.new === true,
            "open-chat-wrapper": _vm.isShowingOpenChat,
          },
        },
        [
          _vm.isShowingLeftAvatarPlaceholder
            ? [
                _vm.isShowingLeftAvatar
                  ? _c(
                      "div",
                      { staticClass: "message-avatar-placeholder" },
                      [
                        _c("customer-avatar", {
                          staticClass: "is-small message-avatar",
                        }),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "message-avatar-placeholder" }),
              ]
            : _vm._e(),
          _vm._v(" "),
          Boolean(_vm.messageTypeComponent)
            ? _c(_vm.messageTypeComponent, {
                tag: "component",
                attrs: { message: _vm.message },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }